export const isAudioBufferSourceNode = (audioNode) => {
    return 'playbackRate' in audioNode;
};
//# sourceMappingURL=audio-buffer-source-node.js.map